<div class="rangeselectorprt">
    <div class="daterange">
        <mat-form-field class="example-form-field" appearance="outline">
        <mat-label>Date Range</mat-label>
            <mat-date-range-input
            [formGroup]="campaignOne"
            [rangePicker]="campaignOnePicker"
            [max]="today">
            <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
            <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #campaignOnePicker>
                <mat-date-range-picker-actions>
                    <button class="apply" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                    <button class="can" mat-button matDateRangePickerCancel>Cancel</button>
                </mat-date-range-picker-actions>
            </mat-date-range-picker>
        </mat-form-field>
    </div>
</div>


<ul class="listcont">
   
    <li class="pointer" (click)="changeTabName('conversions')">
        Conversion Number
        <span class="red">{{analyticsDetails?.conversionNumber | number}}</span>
    </li>
    <li class="pointer" (click)="changeTabName('conversions')">
        Conversion Percent
        <span class="green">{{analyticsDetails?.conversionPercent | number}} %</span>
    </li>
    <li class="pointer" (click)="changeTabName('uniqueUsers')">
        Unique User Count
        <span class="orenge">{{analyticsDetails?.uniqueUserCount | number}}</span>
    </li>
    <li class="pointer" (click)="changeTabName('allPageVisit')">
        Page View Count
        <span class="purple">{{analyticsDetails?.pageViewCount | number}}</span>
    </li>
    <li class="pointer" (click)="changeTabName('soldLeads')">
        Sales Count
        <span class="blue">{{analyticsDetails?.salesCount | number}}</span>
    </li>
    
</ul>
<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current={{listTitle}}></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{listTitle}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <div class="table_container">
            <table [dataSource]="dataSource" mat-table>
                <!-- actions Column -->
                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item routerLink="/audience/analytics-details/{{row?.sessionId}}">
                                <span>View</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
              
                <ng-container matColumnDef="sessionId">
                    <th mat-header-cell *matHeaderCellDef>Session Id</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.sessionId}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalPageVisits">
                    <th mat-header-cell *matHeaderCellDef>Total Page Visits</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.totalPageVisits}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="browserInfo">
                    <th mat-header-cell *matHeaderCellDef>Browser Info</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.browserInfo}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="osInfo">
                    <th mat-header-cell *matHeaderCellDef>Os Info</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.osInfo}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ipAddress">
                    <th mat-header-cell *matHeaderCellDef>Ip Address</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.ipAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef>City</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.city}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="country">
                    <th mat-header-cell *matHeaderCellDef>Country</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.country}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="utmSource">
                    <th mat-header-cell *matHeaderCellDef>Utm Source</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.utmSource}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="internalUrl">
                    <th mat-header-cell *matHeaderCellDef>Internal Url</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.internalUrl}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="referralUrl">
                    <th mat-header-cell *matHeaderCellDef>Referral Url</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.referralUrl}}
                    </td>
                </ng-container>
    
                <ng-container matColumnDef="addedOn">
                    <th mat-header-cell *matHeaderCellDef>Added On</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.addedOn | date : 'MMM-dd-YYYY h:mm a'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>First Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.firstName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>Last Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.lastName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef>Email Address</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.emailAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="mobileNumber">
                    <th mat-header-cell *matHeaderCellDef>Mobile Number</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.mobileNumber}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="source">
                    <th mat-header-cell *matHeaderCellDef>Source</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.source}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="soldAmount">
                    <th mat-header-cell *matHeaderCellDef>Sold Amount</th>
                    <td mat-cell *matCellDef="let element">
                        $ {{element?.soldAmount || 0}}
                    </td>
                </ng-container>
    
                 
                <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns"
                    class="clickable route-animations-elements" mat-row>
                </tr>
              </table>
        </div>
        
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No data found.
        </div>
        
          <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
                  showFirstLastButtons
                  [selectConfig] = "selectConfig"
                  [ngClass]="{'mat-pegig': pageSize === 9999}"
                  aria-label="Select page of periodic elements">
              </mat-paginator>
  
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  





